<template>
    <div class="step contact">
        <AdvTitle class="mb-8">{{ $t("common:signLog.adv.contactTitle",{counts: params.counts}) }}</AdvTitle>
        <AdvSubTitle class="sut-1"
        >{{ $t("common:signLog.adv.contactSubTitle") }}</AdvSubTitle
        >
        <AdvBtn
            class="mt-20 mb-10"
            :width="!isMobileSize ? '255px' : ''"
            col="block"
            @click="handleNext(true)"
        >{{ $t("common:signLog.adv.contactAdvBtn") }}</AdvBtn
        >
        <AdvBtn
            class="mb-15"
            :width="!isMobileSize ? '255px' : ''"
            col="block"
            type="reverse"
            @click="handleNext(false)"
        >{{ $t("common:signLog.adv.contactAdvBtnNo") }}</AdvBtn
        >
        <AdvDescript class="pb-30 bt"
        >{{ $t("common:signLog.adv.contactAdvDesc") }}</AdvDescript
        >
        <AdvProgress
            class="pt-30"
            :value="progress()"
            v-if="!isMobileSize"
        ></AdvProgress>
    </div>
</template>
<script>
import AdvBtn from './components/btn.vue';
import AdvDescript from './components/descript.vue';
import AdvProgress from './components/progress.vue';
import AdvSubTitle from './components/subTitle.vue';
import AdvTitle from './components/title.vue';
export default {
    inject: ['progress', 'next', 'params'],
    data: function() {
        return {};
    },
    computed: {
        isMobileSize() {
            return this.platform.isMobile
        },
    },
    methods: {
        handleNext(contact) {
            this.next({ call: contact }, 'questionAnswer');
        }
    },
    components: {
        AdvBtn,
        AdvDescript,
        AdvProgress,
        AdvSubTitle,
        AdvTitle
    }
};
</script>
<style lang="scss">
.contact {
    display: flex;
    flex-direction: column;
    align-items: center;
}
</style>
